import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getSpecificationItem } from './helpers.js';

const SpecificationItem = ({ config , variant  })=>{
    const { getLabel , locale  } = useIntl();
    const item = getSpecificationItem(config, variant, getLabel, locale);
    if (!item) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "legacy-product-detail-specification__item",
        "data-t": "specification-item",
        role: "presentation"
    }, /*#__PURE__*/ React.createElement("dt", {
        className: "legacy-product-detail-specification__item--label"
    }, item.label), /*#__PURE__*/ React.createElement("dd", {
        className: "legacy-product-detail-specification__item--value"
    }, item.value));
};
var SpecificationItem$1 = /*#__PURE__*/ React.memo(SpecificationItem);

export { SpecificationItem$1 as default };
//# sourceMappingURL=SpecificationItem.js.map
